export default __webpack_public_path__ + "static/media/gallery_05.228a4f02.jpg";